import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { toQueryString } from '../../shared/helpers/helpers';
import { GetSummaryWithWeeklyTrendRequestParams, GetSummaryWithWeeklyTrendResponse } from '../../interfaces/dashboards.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardsService {
  private apiUrl = environment.api + '/dashboard/transactionDetails';

  constructor(private http: HttpClient) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getSummaryWithWeeklyTrend(requestParams: GetSummaryWithWeeklyTrendRequestParams): Observable<GetSummaryWithWeeklyTrendResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetSummaryWithWeeklyTrendResponse>(url).pipe(
      tap((response) => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError((error) => this.handleError(error)) // ✅ Pakai arrow function
    );
  }
}
